<template>
  <div class="modal-body">
    <canvas id="grafico-impegni"></canvas>
  </div>
</template>
    
<script>
import Chart from "chart.js";
Chart.defaults.global.defaultFontFamily = "Karla";
Chart.defaults.global.defaultFontSize = 15;

export default {
  name: "grafico-app",
  data() {
    return {
      barColors: [
        "#350D23",
        "#541C2D",
        "#733136",
        "#92574B",
        "#B1876B",
        "#D0B990",
        "#EFE8BA",
      ],
    };
  },
  mounted() {
    this.$root.grafico = new Chart("grafico-impegni", {
      type: "bar",
      data: {
        labels: this.$root.xValues,
        datasets: [
          {
            barPercentage: 0.9,
            minBarLength: 0,
            backgroundColor: this.barColors,
            data: this.$root.yValues,
          },
        ],
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                callback: function (label) {
                  if (label <= 0) {
                    return;
                  } else if (Number.isInteger(label)) {
                    return label;
                  }
                },
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                autoSkip: false,
                maxRotation: 90,
                minRotation: 90,
              },
            },
          ],
        },
        responsive: true,
        legend: {
          display: false,
        },
        title: {
          display: false,
        },
      },
    });
  },
};
</script>
    
<style scoped>
</style>